import React from 'react'
import Select from 'react-select'

export type IChrMainSelectFilterType = boolean | null

interface IChrMainSelectProps {
  value: IChrMainSelectFilterType
  onChange: (value: IChrMainSelectFilterType) => void
}

const SELECT_OPTIONS = [
  { value: true, label: '메인 캐릭터만' },
  { value: false, label: '보조 캐릭터만' },
  { value: null, label: '모든 캐릭터' },
]

export const ChrMainSelect: React.FC<IChrMainSelectProps> = (props) => {
  const { value, onChange } = props
  return (
    <Select
      placeholder="메인 캐릭터 여부"
      value={SELECT_OPTIONS.find((v) => v.value === value)}
      // @ts-ignore
      onChange={(v) => onChange(v.value)}
      options={SELECT_OPTIONS}
      styles={{
        // Fixes the overlapping problem of the component
        menu: (provided) => ({ ...provided, zIndex: 2 }),
      }}
    />
  )
}
